// https://www.sanity.io/docs/apis-and-sdks/image-urls
import { SANITY_PROJECT_ID } from '@constants/sanity';
import { SanityImage } from 'types/sanity';

export function generateSanityImageUrl(image?: SanityImage): string {
	const environment = import.meta.env.VITE_SANITY_ENV;

	if (!image?.asset?._ref) return '';

	const assetInfo = image.asset._ref.replace('image-', '');
	const [hash, size, format] = assetInfo.split('-');
	const [width, height] = size.split('x');
	return `https://cdn.sanity.io/images/${SANITY_PROJECT_ID}/${environment}/${hash}-${width}x${height}.${format}`;
}
